import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import ScrollToTop from './components/ScrollToTop'
import Home from './pages/Home'
import Veranstaltung from './pages/Veranstaltung'
import Veranstaltungen from './pages/Veranstaltungen'
import Raeume from './pages/Raeume'
import RaumDetail from './pages/RaumDetail'
import Kontakt from './pages/Kontakt'
import Partys from './pages/Partys'
import EventDetail from './pages/EventDetail'
import PartysKarneval from './pages/PartysKarneval'
import Galerie from './pages/Galerie'
import Geschichte from './pages/Geschichte'
import BuffetsAngebote from './pages/BuffetsAngebote'
import Foodtruck from './pages/Foodtruck'
import Jobs from './pages/Jobs'
import Impressum from './pages/Impressum'
import Datenschutz from './pages/Datenschutz'
import Hochzeiten from './pages/Hochzeiten'
import Unternehmensfeiern from './pages/Unternehmensfeiern'
import PrivateFeiern from './pages/PrivateFeiern'
import Brunch from './pages/Brunch'
import BrunchDetail from './pages/BrunchDetail'
import Dashboard from './pages/Dashboard/Dashboard'
import DashboardLogin from './pages/Dashboard/Login'
import NotFound from './pages/NotFound'

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="veranstaltung" element={<Veranstaltung />} />
        <Route path="veranstaltungen" element={<Veranstaltungen />} />
        <Route path="raeume" element={<Raeume />} />
        <Route path="raeume/:slug" element={<RaumDetail />} />
        <Route path="kontakt" element={<Kontakt />} />
        <Route path="partys/:eventSlug" element={<EventDetail />} />
        <Route path="partys" element={<Partys />} />
        <Route path="partys-karneval" element={<PartysKarneval />} />
        <Route path="brunch" element={<Brunch />} />
        <Route path="brunch/:brunchId" element={<BrunchDetail />} />
        <Route path="hochzeiten" element={<Hochzeiten />} />
        <Route path="unternehmensfeiern" element={<Unternehmensfeiern />} />
        <Route path="private-feiern" element={<PrivateFeiern />} />
        <Route path="galerie" element={<Galerie />} />
        <Route path="geschichte" element={<Geschichte />} />
        <Route path="buffets-angebote" element={<BuffetsAngebote />} />
        <Route path="foodtruck" element={<Foodtruck />} />
        <Route path="jobs" element={<Jobs />} />
        <Route path="impressum" element={<Impressum />} />
        <Route path="datenschutz" element={<Datenschutz />} />
        {/* 404 - Catch all - innerhalb des Layouts */}
        <Route path="*" element={<NotFound />} />
      </Route>
      
      {/* Dashboard Routes */}
      <Route path="/dashboard/login" element={<DashboardLogin />} />
      <Route path="/dashboard/*" element={<Dashboard />} />
    </Routes>
    </>
  )
}

export default App














